document.addEventListener('DOMContentLoaded', () => {
  const CONSENT_KEY = 'cookieConsent';
  const CONSENT_VALUE = true;

  const cookieModal = document.querySelector('.cookies');
  const acceptButton = cookieModal.querySelector('.cookies__cta');

  function closeCookieModal() {
    cookieModal.setAttribute('aria-hidden', 'true');
  }

  function openCookieModal() {
    cookieModal.setAttribute('aria-hidden', 'false');
  }

  function checkCookieConsent() {
    const consent = localStorage.getItem(CONSENT_KEY);

    if (!consent) {
      openCookieModal();
    }
  }

  function handleCookieAccept() {
    localStorage.setItem(CONSENT_KEY, CONSENT_VALUE);
    closeCookieModal();
  }

  acceptButton.addEventListener('click', handleCookieAccept);

  checkCookieConsent();
});
